module.exports = __webpack_public_path__ + "img/ic_negotiable.aa00794d.svg";